import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useApi } from "../../app/api-context";

export const USERS_QUERY_KEY = ["users"] as const;

export function useUsers() {
  const api = useApi();
  return useQuery({ queryKey: USERS_QUERY_KEY, queryFn: () => api.listUsers() });
}

/** Runs a change and refreshes the user list afterwards, whatever the outcome. */
export function useUserMutation<TVariables, TResult>(
  mutationFn: (variables: TVariables) => Promise<TResult>,
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSettled: () => queryClient.invalidateQueries({ queryKey: USERS_QUERY_KEY }),
  });
}
